// extracted by mini-css-extract-plugin
export var container = "_5x-0";
export var error = "_5x-9";
export var label = "_5x-5";
export var light = "_5x-6";
export var md = "_5x-3";
export var sm = "_5x-2";
export var thin = "_5x-8";
export var thinBold = "_5x-7";
export var vertical = "_5x-4";
export var xs = "_5x-1";